import store from "../store";

export const commonService = {
  getRessource,
  downloadFile,
  handleUnsuccessfulResponse,
  handleNoResponse,
  handleAnyResponse,
};

// Fetch de type GET et gestion des différentes réponses HTTP
function getRessource(url) {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + store.getters.token,
    }
  };

  return fetch(url, requestOptions)
    .then(response => {
      if (response) {
        // Réponse HTTP de success
        if (response.ok) {
          // OK
          if (response.status == 200) {
            return response.json();
          } else if (response.status == 204) {
            return response.text();
          }
          // Autres réponses
        } else {
          let notificationTextMessage = "Une erreur est survenue";
          let notificationIcon = "ti-alert pt-1";
          let notificationType = "danger";

          // Forbidden
          if (response.status == 403) {
            notificationTextMessage =
              "Vous avez tenté d'accéder à une ressource non autorisée";
            notificationIcon = "ti-lock pt-1";
            // Internal Server Error
          } else if (response.status == 500) {
            notificationTextMessage = "Le serveur a rencontré une erreur";
            notificationIcon = "ti-alert pt-1";
          }

          store.dispatch("saveTextNotification", {
            notificationIcon,
            notificationType,
            notificationTextMessage
          });

          throw Error(`Request rejected with status ${response.status}`);
        }
      } else {
        const notificationIcon = "ti-alert pt-1";
        const notificationType = "danger";
        const notificationTitle = "La connexion a été interrompue";
        const notificationJsonMessage = ["Veuillez réactualiser la page"];

        store.dispatch("saveJsonNotification", {
          notificationTitle,
          notificationIcon,
          notificationType,
          notificationJsonMessage
        });
      }
    })
    .catch(err => {
      console.log(err);
    });
}

// Fetch de type GET et gestion des différentes réponses HTTP
function downloadFile(url) {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + store.getters.token,
      Profil: store.getters.profil
    },
    responseType: 'blob'
  };

  return fetch(url, requestOptions)
    .then(async (response) => {
      if (response) {
        // Réponse HTTP de success
        if (response.ok) {
          let contentDisposition = null;
          let contentType = 'application/pdf';
          let filename = "export";

          for(let entry of response.headers.entries()) {
            if (entry[0] === 'content-disposition') {
              contentDisposition = entry[1];
            }
            if (entry[0] === 'content-type') {
              contentType = entry[1];
            }
          }

          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }

          const blob = new Blob([await response.blob()], { type: contentType });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          URL.revokeObjectURL(link.href);
        } else {
          // Autres réponses
          let notificationTextMessage = "Une erreur est survenue";
          let notificationIcon = "ti-alert pt-1";
          let notificationType = "danger";

          // Forbidden
          if (response.status == 403) {
            notificationTextMessage =
              "Vous avez tenté d'accéder à une ressource non autorisée";
            notificationIcon = "ti-lock pt-1";
            // Internal Server Error
          } else if (response.status == 500) {
            notificationTextMessage = "Le serveur a rencontré une erreur";
            notificationIcon = "ti-alert pt-1";
          }

          store.dispatch("saveTextNotification", {
            notificationIcon,
            notificationType,
            notificationTextMessage
          });

          throw Error(`Request rejected with status ${response.status}`);
        }
      } else {
        const notificationIcon = "ti-alert pt-1";
        const notificationType = "danger";
        const notificationTitle = "La connexion a été interrompue";
        const notificationJsonMessage = ["Veuillez réactualiser la page"];

        store.dispatch("saveJsonNotification", {
          notificationTitle,
          notificationIcon,
          notificationType,
          notificationJsonMessage
        });
      }
    }).catch(error => {
      console.log(error);
    });
}

// Ajoute une notification en fonction du statut de la réponse HTTP
function handleUnsuccessfulResponse(response) {
  if (response) {
    let notificationTextMessage = "Une erreur est survenue";
    let notificationIcon = "ti-alert pt-1";
    let notificationType = "danger";

    // Forbidden
    if (response.status == 403) {
      notificationTextMessage =
        "Vous avez tenté d'accéder à une ressource non autorisée";
      notificationIcon = "ti-lock pt-1";
      // Internal Server Error
    } else if (response.status == 500) {
      notificationTextMessage = "Le serveur a rencontré une erreur";
      notificationIcon = "ti-alert pt-1";
    }

    store.dispatch("saveTextNotification", {
      notificationIcon,
      notificationType,
      notificationTextMessage
    });

    throw Error(`Request rejected with status ${response.status}`);
  } else {
    const notificationIcon = "ti-alert pt-1";
    const notificationType = "danger";
    const notificationTitle = "La connexion a été interrompue";
    const notificationJsonMessage = ["Veuillez réactualiser la page"];

    store.dispatch("saveJsonNotification", {
      notificationTitle,
      notificationIcon,
      notificationType,
      notificationJsonMessage
    });
  }
}

// Ajoute une notification si pas dé réponse HTTP
function handleNoResponse() {
  const notificationIcon = "ti-alert pt-1";
  const notificationType = "danger";
  const notificationTitle = "La connexion a été interrompue";
  const notificationJsonMessage = ["Veuillez réactualiser la page"];

  store.dispatch("saveJsonNotification", {
    notificationTitle,
    notificationIcon,
    notificationType,
    notificationJsonMessage
  });
}


// Ajoute une notification quelque soit la réponse
function handleAnyResponse(response) {
  if (response) {
    // OK
    if (response.status == "200") {
      response.text().then(message => {
        const notificationTextMessage = message;
        const notificationIcon = "ti-check";
        const notificationType = "success";

        store.dispatch("saveTextNotification", {
          notificationIcon,
          notificationType,
          notificationTextMessage
        });

      });
      // BAD REQUEST
    } else if (response.status == "400") {
      response.json().then(message => {
        const notificationJsonMessage = message;
        const notificationTitle =
          "Les modifications n'ont pas été prises en compte";
        const notificationIcon = "ti-alert";
        const notificationType = "danger";

        store.dispatch("saveJsonNotification", {
          notificationTitle,
          notificationIcon,
          notificationType,
          notificationJsonMessage
        });
      });

      // Other HTTP response
    } else {
      let notificationIcon = "ti-alert pt-1";
      let notificationType = "danger";
      let notificationTextMessage = "Une erreur est survenue";

      // FORBIDDEN
      if (response.status == "403") {
        notificationIcon = "ti-lock pt-1";
        notificationTextMessage =
          "Vous avez tenté d'accéder à une ressource non autorisée";

        // INTERNAL ERROR
      } else if (response.status == "500") {
        notificationTextMessage = "Le serveur a rencontré une erreur";
      }

      store.dispatch("saveTextNotification", {
        notificationIcon,
        notificationType,
        notificationTextMessage
      });

      throw Error(`Request rejected with status ${response.status}`);
    }
  } else {
    const notificationIcon = "ti-alert pt-1";
    const notificationType = "danger";
    const notificationTitle = "La connexion a été interrompue";
    const notificationJsonMessage = ["Veuillez réactualiser la page"];

    store.dispatch("saveJsonNotification", {
      notificationTitle,
      notificationIcon,
      notificationType,
      notificationJsonMessage
    });
  }
}
